module.exports = __webpack_public_path__ + "media/images/talent/intro-logo-9242610367c5bfd1d19752a32973ba7d.png";